import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from './app/components/components.module';
import { AppRoutingModule } from './app/app.routing';
import { SharedModule } from './app/shared/shared.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { GoogleLoginProvider, SOCIAL_AUTH_CONFIG, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(FormsModule, ComponentsModule, AppRoutingModule, SharedModule, MatGridListModule, ReactiveFormsModule, NgIdleKeepaliveModule.forRoot(), MatAutocompleteModule, SocialLoginModule),
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleClientId)
          }
        ],
        onError: (err: any) => console.error(err)
      } as SocialAuthServiceConfig,
    },
    DatePipe,
    CurrencyPipe,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
  .catch(err => console.error(err));
